import { useStaticQuery, graphql } from 'gatsby';

const useBlogCategories = () => {
  const blogCategories = useStaticQuery(
    graphql`
      query {
        allSanityBlogCategory(sort: { fields: orderPriority, order: DESC }) {
          edges {
            node {
              id
              title
              slug {
                current
              }
            }
          }
        }
      }
    `,
  );
  return blogCategories;
};

export default useBlogCategories;
